export const SRCSET_SIZES = [400, 640, 960, 1280, 1440] as const;

export function getSrcsetUrl(url: string, width: number): string {
    return `${url}?disable=upscale&auto=webp&quality=60&width=${width}`;
}

export function getSrcsetString(url: string): string | undefined {
    return url
        ? SRCSET_SIZES.map(width => `${getSrcsetUrl(url, width)} ${width}w`).join(', ')
        : undefined;
}
